import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useUserContext } from 'store/contexts/userContext';


export default function AuthenticatedRoute({ children, ...rest }) {
  const { pathname, search } = useLocation();
  const { isAuthenticated } = useUserContext();

  return (
    <Route {...rest}>
      {isAuthenticated ? (
        children
      ) : (
          <Redirect to={
            `/login?redirect=${pathname}${search}`
          }
          />
        )}
    </Route>
  );
}
